// import external dependencies

import "jquery";
import "./autoload/_bootstrap.js";
jQuery(document).ready(function(){

	$(".sidebar-menu ul.dropdown-submenu").hide();

	$(".dropdown-submenu-toggle, .dropdown-toggle").on("click", function(e) {
		if (!$(e.target).hasClass("caret")) {
			window.location.href = $(this).attr("href");
		} else if ($(this).children("span:first").is(e.target)) {
			window.location.href = $(this).attr("href");
		}
	});

	// mega menu mobile
	$(".sidebar-menu .menu-item a").on("click", function(e) {
		var element = $(this);
		if ($(this).hasClass("dropdown-submenu-toggle")) {
			$(this).parent().parent().find("li").each(function() {
				var b = $(this).find("a");
				if ($(this).find("ul.dropdown-submenu").is(":visible")) {
					if (b.data("id") != element.data("id")) {
						$(this).find("ul.dropdown-submenu").hide();
						$(this).find("a.dropdown-submenu-toggle").toggleClass("show");
						$(this).find("span").toggleClass("active");
					}
				}
			});
			$(this).next("ul.dropdown-submenu").toggle();
			$(this).find(".caret").toggleClass("active");
			$(this).toggleClass("show");
		}

		if ($(this).next("ul").hasClass("dropdown-menu")) {
			$(".sidebar-menu .menu-item a").each(function() {
				var a = $(this);
				if ($(this).next("ul.dropdown-menu").is(":visible")) {
					if (a.data("id") != element.data("id")) {
						$(this).next("ul.dropdown-menu").hide();
						$(this).find("a.dropdown-submenu-toggle").toggleClass("show");
						$(this).find("span").toggleClass("active");
						var submenuActive = $(this).next("ul.dropdown-menu").find("li.menu-item a.dropdown-submenu-toggle.show");
						submenuActive.toggleClass("show");
						submenuActive.find("span.caret").toggleClass("active");
					} else {
						$(this).next("ul.dropdown-menu").find("li.menu-item").each(function() {
							var item = $(this).find("a.dropdown-submenu-toggle.show");
							item.toggleClass("show");
							item.find("span.caret").toggleClass("active");
						});
					}
				}
			});

			$(this).next("ul.dropdown-menu").toggle();
			if ($(this).closest("li.megamenu-item").length) {
				$(this).next("ul.dropdown-menu").find("ul.dropdown-submenu").hide();
			}
			$(this).find(".caret").toggleClass("active");
		}
		e.stopPropagation();
		e.preventDefault();

		if (!$(e.target).hasClass("caret")) {
			window.location.href = $(this).attr("href");
		}
	});

	// mega menu desktop - invert dropdown side if not fit on border-right
	var dropdownMenus = document.querySelectorAll(".dropdown-menu");
	dropdownMenus.forEach(function(dropdownMenu) {
		var dropdownParent = dropdownMenu.parentNode;
		dropdownParent.addEventListener("mouseenter", function() {
			var dropdownMenuRect = dropdownMenu.getBoundingClientRect();
			var windowWidth = window.innerWidth;
			if (dropdownMenuRect.right > windowWidth) {
				dropdownMenu.classList.add("invert-side");
			}
		});
		dropdownParent.addEventListener("mouseleave", function() {
			dropdownMenu.classList.remove("invert-side");
		});
	});

	/**
	 * @desc toggle sidebar
	 */
	$(".navbar-toggler, .page-overlay").on("click", function() {
		$(".sidebar-menu, .page-overlay").toggleClass("active");
		$(".sidebar-menu .menu-item a").each(function() {
			if ($(this).next("ul.dropdown-menu").is(":visible")) {
				$(this).next("ul.dropdown-menu").hide();
				$(this).find(".caret").toggleClass("active");
			}
		});
		$(".navbar-toggler").toggleClass("active");
		$("body").toggleClass("noscroll");

		if ($("header.header").hasClass("light")) {
			$("img.brand__img_light").toggle();
			$("img.brand__img").toggle();
			var span = $(".navbar-toggler span").css("background", "white");
			var currentBg = span.css("background-color");
			var targetBgColor = currentBg === "rgb(0, 0, 0)" ? "white" : "black";
			span.css("background-color", targetBgColor);
		}
	});

	if($('.header.initial-stage.using-disclaimer').length && $('.global-disclaimer').length){
		$('body').append("<style>.header.initial-stage.using-disclaimer{top: "+$('.global-disclaimer').innerHeight()+"px;}");
	}

	const eventLLS = new Event('lazyLoadScripts');
	var app = {
		init: function() {
			window.addEventListener("scroll", function() {
				if (window.__he == undefined) {
					app.load();
				}
			});
			window.addEventListener("mousemove", function() {
				if (window.__he == undefined) {
					app.load();
				}
			});
		},
		load: function() {
			window["__he"] = true;
			setTimeout(function (){
				window.dispatchEvent(eventLLS);
				console.log('Lazyload Scripts triggered')
			}, 100);
		},
	};

	window.addEventListener('lazyLoadScripts', function () {
		var jsScript = document.createElement('script');
		jsScript.src = '/wp-content/themes/apostalegal/dist/scripts/defered.js?v=2.0.1';
		document.body.appendChild(jsScript);
	}, false);
	app.init();
});

// Truncated Selector for elements that have scroll height/width higher than then innerHeight/innerWidth
$.expr[':'].truncated = function(obj) {
	var element = $(obj);
	return (element[0].scrollHeight > (element.innerHeight() + 2)) || (element[0].scrollWidth > (element.innerWidth() + 2));
};

//NO need for self link at menu
$('.menu-item a[href="'+window.location.href+'"]').attr("href", '#');

document.addEventListener("DOMContentLoaded", function() {

	/**
	 * @desc onLoad scroll smooth
	 */
	if (window.location.hash && $(window.location.hash).length) {
		var offset = jQuery(window.location.hash).offset().top;
		$('html, body').animate({ scrollTop: (offset / 1.5) }, 1000, 'swing');

		setTimeout(function(){
			$('html, body').animate({ scrollTop: (jQuery(window.location.hash).offset().top - 120) }, 700, 'swing');
		}, 1000); //wait a second to make sure we know the place
	}

	//makesure wprocketLazyload will load
	var observer = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				var lazyElement = $(entry.target);
				if (lazyElement.attr('data-lazy-src')) {
					lazyElement.attr('src', lazyElement.attr('data-lazy-src'));
				}
				if (lazyElement.attr('data-lazy-srcset')) {
					lazyElement.attr('srcset', lazyElement.attr('data-lazy-srcset'));
				}
				if (lazyElement.attr('data-bg')) {
					lazyElement.attr('style', 'background-image: url('+lazyElement.attr('data-bg')+');');
					lazyElement.removeAttr('data-bg');
				}
				observer.unobserve(entry.target);
			}
		});
	});

	function observeLazyLoading() {
		$('[data-lazy-src], [data-lazy-srcset], [data-bg]').each(function () {
			observer.observe(this);
		});
	}
	observeLazyLoading();
	const domObserver = new MutationObserver(() => {
		observeLazyLoading();
		console.log('Observing changes.');
	});
	domObserver.observe(document.body, {childList: true, subtree: true});
});



// WEBPACK FOOTER //
// ./scripts/main.js